import { IUser } from "@iloq/shared/IUser";

const defaultRepairServicePriceListFilename = "repair_service_price_list_2023_EN.pdf";
const repairServicePriceListFilenameByCountryCode: { [key: string]: string } = {
  CA: "repair_service_price_list_2023_CA.pdf",
  DK: "repair_service_price_list_2023_DA.pdf",
  DE: "repair_service_price_list_2023_DE.pdf",
  FI: "repair_service_price_list_2023_FI.pdf",
  FR: "repair_service_price_list_2023_FR.pdf",
  NL: "repair_service_price_list_2023_NL.pdf",
  NO: "repair_service_price_list_2023_NO.pdf",
  PL: "repair_service_price_list_2023_PL.pdf",
  SE: "repair_service_price_list_2023_SV.pdf",
  // IT: no specific price list available, use default
  // GB: no specific price list available, use default
  // US: no specific price list available, use default
};

export const getRepairServicePriceListUrl = (user: IUser) => {
  return `/files/support/${
    repairServicePriceListFilenameByCountryCode[user.countryCode] ||
    defaultRepairServicePriceListFilename
  }`;
};
